"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _GenericStore2 = _interopRequireDefault(require("./../../../../KESI2/Stores/GenericStore"));

var _MessagingService = _interopRequireDefault(require("../../MessagingService"));

var _BuildConstants = require("../../../../utils/BuildConstants");

var _store = _interopRequireDefault(require("store"));

var _LogActions = _interopRequireDefault(require("./LogActions"));

var _ResumeSuspendListeners = require("../../../../helpers/ResumeSuspendListeners");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var LOG_EVENT_NAME = 'enter';
var LOG_CHANNEL = "".concat(_BuildConstants.ABLY_CHANNEL_PREFIX, "USAGE_LOG");
var LOG_STORE_PATHS = {
  LOG_QUEUE_NAME: 'logMessageQueue'
};

var LogStore = /*#__PURE__*/function (_GenericStore) {
  (0, _inherits2["default"])(LogStore, _GenericStore);

  var _super = _createSuper(LogStore);

  function LogStore() {
    var _this;

    (0, _classCallCheck2["default"])(this, LogStore);
    _this = _super.call(this);

    _this.init();

    return _this;
  }

  (0, _createClass2["default"])(LogStore, [{
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _MessagingService["default"].waitForInitialized();

              case 2:
                // set Presence ( implicit init and attach the channel )
                _MessagingService["default"].enterPresence(LOG_CHANNEL);

                _MessagingService["default"].registerConnect(LogStore._renewPresence); // browser event on app stop


                window.addEventListener('unload', function () {
                  _MessagingService["default"].leavePresence(LOG_CHANNEL);
                }, false); // cordova event

                (0, _ResumeSuspendListeners.addOnSuspendListener)(function () {
                  _MessagingService["default"].leavePresence(LOG_CHANNEL);
                }); // cordova event

                (0, _ResumeSuspendListeners.addOnResumeListener)(function () {
                  _MessagingService["default"].enterPresence(LOG_CHANNEL);
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "getList",
    value: function getList() {
      var logQueue = this.getValue(LOG_STORE_PATHS.LOG_QUEUE_NAME);
      return logQueue && logQueue.value ? logQueue.value : [];
    }
  }, {
    key: "logMessageEnqueueAction",
    value: function logMessageEnqueueAction(message) {
      var list = (0, _toConsumableArray2["default"])(this.getList());
      list.push(message);
      this.setValue(LOG_STORE_PATHS.LOG_QUEUE_NAME, {
        value: list
      });

      if (list.length === 1) {
        this.logMessageDequeueAction({});
      }
    }
  }, {
    key: "logMessageDequeueAction",
    value: function () {
      var _logMessageDequeueAction = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var _this2 = this;

        var list, message, channel;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                list = (0, _toConsumableArray2["default"])(this.getList());

                if (!(list.length === 0)) {
                  _context2.next = 4;
                  break;
                }

                this.setValue(LOG_STORE_PATHS.LOG_QUEUE_NAME, {
                  value: list
                });
                return _context2.abrupt("return");

              case 4:
                message = list.shift();
                _context2.next = 7;
                return _MessagingService["default"].getChannel(LOG_CHANNEL);

              case 7:
                channel = _context2.sent;
                _context2.prev = 8;
                _context2.next = 11;
                return _MessagingService["default"].sendMessage(channel, LOG_EVENT_NAME, message);

              case 11:
                console.log('Successfull published', message, new Date().getTime());
                this.setValue(LOG_STORE_PATHS.LOG_QUEUE_NAME, {
                  value: list
                });

                if (list.length > 0) {
                  // min 5ms deferred to prevent order issues at ably
                  setTimeout(function () {
                    _this2.logMessageDequeueAction({});
                  }, 5);
                }

                _context2.next = 20;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](8);
                console.error('Error on send', _context2.t0, message); // repeat same action after 5 seconds

                setTimeout(function () {
                  _this2.logMessageDequeueAction({});
                }, 5000);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 16]]);
      }));

      function logMessageDequeueAction() {
        return _logMessageDequeueAction.apply(this, arguments);
      }

      return logMessageDequeueAction;
    }()
  }], [{
    key: "_renewPresence",
    value: function _renewPresence() {
      _MessagingService["default"].enterPresence(LOG_CHANNEL);
    }
  }]);
  return LogStore;
}(_GenericStore2["default"]);

var logStore = new LogStore();
var _default = logStore;
exports["default"] = _default;